export enum TIME_FORMATS {
  USA = 'h:mm A',
  DEFAULT = 'HH:mm',
}

export enum TIME_FORMATS_MATERIAL {
  USA = 'h:mm aa',
}

export enum DATE_FORMATS {
  USA = 'MM-DD-YYYY',
  DEFAULT = 'DD-MM-YYYY',
}

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD'
export const BACKEND_TIME_FORMAT = 'HH:mm:ss'

export enum SHORT_DATE_FORMATS {
  USA = 'MM/DD/YY',
  DEFAULT = 'DD/MM/YY',
}
export enum PREVIEW_INPUT_DATE_FORMATS {
  USA = 'MM-DD-YY',
  DEFAULT = 'DD-MM-YY',
}
